<template>
  <div class="crpg-a-common-item-number code">
    <span class="subtitle">商品番号</span>ライフ：No.{{ itemNumber }}
  </div>
</template>

<script>
export default {
  props: {
    itemNumber: String,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/atoms/common/itemNumberL.scss";
</style>
